import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            最新动态
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            实时追踪平台更新与影视资源上线动态
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300/60 hidden sm:block"></div>
          <div className="flex flex-col gap-4">
            {updatesData.map((item) => (
              <a
                key={item.id}
                href="#carousel"
                className="group relative flex items-start gap-4 sm:gap-6 pl-0 sm:pl-12 py-3 hover:bg-background-100/70 rounded-lg transition-colors duration-200 cursor-pointer"
              >
                <div className="hidden sm:flex absolute left-[15px] top-4 w-2.5 h-2.5 rounded-full bg-accent-500 border-2 border-background-50 flex-shrink-0"></div>
                <div className="sm:hidden flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 text-xs font-medium">
                  <i className="ri-time-line"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 flex-wrap">
                    <span className="text-xs text-foreground-400 font-mono whitespace-nowrap">{item.date}</span>
                    <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-md whitespace-nowrap">{item.tag}</span>
                  </div>
                  <h3 className="mt-1 text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors leading-relaxed">{item.title}</h3>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}